// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import SubscriptionContext from '@/utils/subscription-context';
import ManageBundleComponent from '@/PageComponents/Bundle/ManageBundleComponent';
import Breadcrumbs from '@/components/breadcrumbs';
import { useRouter } from 'next/router';
import bundleService from '@/services/inventory/bundle-service';
import {Box, Card, Flex} from "@mantine/core";
import {useElementSize} from "@mantine/hooks";
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'

function EditBundle() {
  const subscriptionContext = useContext(SubscriptionContext);
  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
  const router = useRouter();
  const { id } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

  const { data: bundle } = useQuery(
    ['bundle', id],
    () => bundleService.getBundle(id as string),
    { enabled: !!id }
  );

  const getAccessStatus = async () => {

    const subscriptionInfo = (subscriptionContext as any).subscriptionInfo;

    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  useEffect(() => {
    getAccessStatus();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(router.replace, "/");
    }
  }, [accessStatus]);

  const {height: toolbarHeight, ref: toolbarRef} = useElementSize()

  if (!bundle) return null;

  return (
    <div>
      <Box bg={'white'} ref={toolbarRef} pb={'sm'}>
        <Flex justify={'apart'} w={'100%'} mt={'15px'} gap={'sm'} px={10}>
          <Flex align={'center'} >
            <Breadcrumbs currPage={{ text: bundle.Name, link: `/bundle/${bundle.ID}`, type: 'bundle-show' }} />
          </Flex>
        </Flex>
      </Box>
      <Box
          bg={'gray.1'}
          py={{base: 5, xs: 8, sm: 'md'}}
          px={{base: 5, xs: 8}}
          mih={`calc(100vh - ${(toolbarHeight ? (toolbarHeight + 68) : 166)}px)`}
      >
        <Card
            p={'md'}
            px={{base: 1, xs: 5, sm: 'sm'}}
            radius={'md'}
            mx={'auto'}
        >
          <ManageBundleComponent bundle={bundle} />
        </Card>
      </Box>
    </div>
  );
}

export default EditBundle;

export const Route = createFileRoute('/_authenticated/bundle/$id')({ component: EditBundle })
